import type { SharedTypes } from '@semios/app-platform-banyan-route-definitions'
import { filterUniqueAndMapToValueAndLabel } from 'App/data-export/store/selectors/_utils/filterUniqueAndMapToValueAndLabel'
import { getDataExportValueTypes } from 'App/data-export/store/selectors/_utils/getDataExportValueTypes'
import { getIdAndEmitterTypeFromZoneEmitterTypeKey } from 'App/Map/_utils/irrigationZoneEmitterTypeKeyUtil'
import { translate } from 'i18n/i18n'
import type { TFieldAssetStoreState } from 'stores/fieldAssetStore/fieldAssetStore'
import { mapApiEmitterTypeToLabel } from 'utils/mapApiEmitterTypeToLabel'

export const fieldAssetsOptions = ({
  propertyId,
  fieldAssetStoreState,
}: {
  propertyId: string | null
  fieldAssetStoreState: TFieldAssetStoreState
}) => {
  const items =
    propertyId !== null
      ? getDataExportValueTypes({
          propertyId: Number(propertyId),
          fieldAssetStoreState,
        })
      : []

  const pointsOptions = filterUniqueAndMapToValueAndLabel({
    items,
    filter: (x) => x.fieldAssetType === 'points',
    uniqueBy: (x) => x.fieldAssetId,
    mapToLabel: (x) => x.fieldAssetName,
  })

  const blocksOptions = filterUniqueAndMapToValueAndLabel({
    items,
    filter: (x) => x.fieldAssetType === 'blocks',
    uniqueBy: (x) => x.fieldAssetId,
    mapToLabel: (x) => x.fieldAssetName,
  })

  const irrigationZoneEmittersOptions = filterUniqueAndMapToValueAndLabel({
    items,
    filter: (x) => x.fieldAssetType === 'irrigation_zones',
    uniqueBy: (x) => x.fieldAssetId,
    mapToLabel: (x) => {
      const { emitterType } = getIdAndEmitterTypeFromZoneEmitterTypeKey(
        x.fieldAssetId as SharedTypes.IrrigationScheduler.TIrrigationZoneEmitterId,
      )

      return translate.phrases.templates('{{labelA}} ({{labelB}})', {
        labelA: x.fieldAssetName,
        labelB: mapApiEmitterTypeToLabel(emitterType),
      })
    },
  })

  return {
    pointsOptions,
    blocksOptions,
    irrigationZoneEmittersOptions,
  }
}
